import 'slick-carousel';

function slider($slider, dots, arrows, slidesToShow, autoplay) {
	if ($slider.length > 0) {
		let $slides = $slider.find('.slider__slides');
		let fade = true;

		if (dots == undefined) {
			dots = false;
		}

		if (arrows == undefined) {
			arrows = false;
		}

		if (slidesToShow == undefined) {
			slidesToShow = 1;
		}

		if (autoplay == undefined) {
			autoplay = true;
		}

		if (slidesToShow > 1) {
			fade = false;
		}

		$slides.slick({
			dots: dots,
			arrows: arrows,
			slidesToShow: slidesToShow,
			slidesToScroll: 1,
			speed: 1000,
			centerMode: false,
			variableWidth: false,
			adaptiveHeight: false,
			fade: fade,
			autoplay: autoplay,
			autoplaySpeed: 5000,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});
	}
}

export default slider;
